/* Moglee Base — quick add sheet. "Choose options" on a card opens a sheet to pick
   size, colour or any option and add to the bag without leaving the page. */

(function () {
  if (window.__mbQuickAdd) return;
  window.__mbQuickAdd = true;

  var self = document.currentScript;
  ['css', 'swipe.js'].forEach(function (part) {
    if (!self || !self.src) return;
    var url = self.src.replace('mb-quickadd.js', part === 'css' ? 'mb-quickadd.css' : 'mb-quickadd-' + part);
    var node = document.createElement(part === 'css' ? 'link' : 'script');
    if (part === 'css') {
      node.rel = 'stylesheet';
      node.href = url;
    } else {
      node.src = url;
    }
    document.head.appendChild(node);
  });

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var rootEl = document.documentElement;
  var cache = {};
  var ui = null;
  var state = { product: null, values: [], variant: null, opener: null, moneyFormat: '', token: 0, busy: false, prevOverflow: '' };

  function el(tag, attrs, text) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (key) {
      node.setAttribute(key, attrs[key]);
    });
    if (text) node.textContent = text;
    return node;
  }

  function digits(cents, places, thousands, decimal) {
    var parts = (cents / 100).toFixed(places).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function money(cents) {
    var format = state.moneyFormat;
    if (!format) {
      try {
        var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, name) {
      var places = name.indexOf('no_decimals') === -1 ? 2 : 0;
      return name.indexOf('comma') === -1 ? digits(cents, places, ',', '.') : digits(cents, places, '.', ',');
    });
  }

  function sized(url, width) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function optionName(product, index) {
    var option = product.options[index];
    return typeof option === 'string' ? option : option.name;
  }

  function optionValues(product, index) {
    var option = product.options[index];
    if (option && option.values) return option.values;
    var seen = [];
    product.variants.forEach(function (variant) {
      var value = variant['option' + (index + 1)];
      if (seen.indexOf(value) === -1) seen.push(value);
    });
    return seen;
  }

  function matches(variant, values) {
    for (var i = 0; i < values.length; i++) {
      if (values[i] !== null && variant['option' + (i + 1)] !== values[i]) return false;
    }
    return true;
  }

  function findVariant(values, availableOnly) {
    var list = state.product.variants;
    for (var i = 0; i < list.length; i++) {
      if (matches(list[i], values) && (!availableOnly || list[i].available)) return list[i];
    }
    return null;
  }

  function build() {
    var wrap = el('div', { class: 'mb mb-qa', 'data-open': 'false', 'data-state': 'loading' });
    wrap.innerHTML =
      '<div class="mb-qa__overlay" data-mb-qa-close></div>' +
      '<div class="mb-qa__panel" role="dialog" aria-modal="true" aria-labelledby="mb-qa-title" tabindex="-1">' +
      '<div class="mb-qa__grab" data-mb-qa-grab aria-hidden="true"><span></span></div>' +
      '<div class="mb-qa__head" data-mb-qa-grab>' +
      '<div class="mb-qa__thumb"><img alt="" data-mb-qa-img></div>' +
      '<div class="mb-qa__info"><h2 class="mb-qa__title" id="mb-qa-title" data-mb-qa-title></h2><p class="mb-qa__price" data-mb-qa-price></p></div>' +
      '<button type="button" class="mb-qa__close" data-mb-qa-close aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="mb-qa__body" data-mb-qa-body></div>' +
      '<div class="mb-qa__foot">' +
      '<p class="mb-qa__msg" role="status" aria-live="polite" data-mb-qa-msg></p>' +
      '<button type="button" class="mb-buy__submit mb-qa__submit" data-mb-qa-submit disabled>Select size</button>' +
      '<a class="mb-qa__more" data-mb-qa-more href="#">View full details</a>' +
      '</div>' +
      '<div class="mb-qa__done">' +
      '<p class="mb-qa__done-text" role="status" data-mb-qa-done></p>' +
      '<a class="mb-buy__submit mb-qa__submit mb-qa__bag" data-mb-qa-bag href="#">View bag</a>' +
      '<button type="button" class="mb-qa__continue" data-mb-qa-close>Continue shopping</button>' +
      '</div>' +
      '</div>';
    document.body.appendChild(wrap);

    ui = {
      wrap: wrap,
      panel: wrap.querySelector('.mb-qa__panel'),
      img: wrap.querySelector('[data-mb-qa-img]'),
      title: wrap.querySelector('[data-mb-qa-title]'),
      price: wrap.querySelector('[data-mb-qa-price]'),
      body: wrap.querySelector('[data-mb-qa-body]'),
      msg: wrap.querySelector('[data-mb-qa-msg]'),
      submit: wrap.querySelector('[data-mb-qa-submit]'),
      more: wrap.querySelector('[data-mb-qa-more]'),
      done: wrap.querySelector('[data-mb-qa-done]'),
      bag: wrap.querySelector('[data-mb-qa-bag]')
    };
    ui.bag.setAttribute('href', routeRoot + 'cart');

    wrap.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.type !== 'radio') return;
      state.values[parseInt(input.getAttribute('data-index'), 10)] = input.value;
      ui.msg.textContent = '';
      update();
    });
    ui.submit.addEventListener('click', add);

    document.dispatchEvent(new CustomEvent('mb:qa:ready', { detail: { wrap: wrap, panel: ui.panel, close: closeSheet } }));
  }

  function renderOptions(product) {
    ui.body.textContent = '';
    state.values = [];

    product.options.forEach(function (option, index) {
      var values = optionValues(product, index);
      state.values.push(values.length === 1 ? values[0] : null);

      var fieldset = el('fieldset', { class: 'mb-qa__option' });
      var legend = el('legend', { class: 'mb-qa__label' }, optionName(product, index) + ' — ');
      legend.appendChild(el('b', { 'data-mb-qa-chosen': String(index) }));
      fieldset.appendChild(legend);

      var row = el('div', { class: 'mb-qa__values' });
      values.forEach(function (value, n) {
        var id = 'mb-qa-' + index + '-' + n;
        var input = el('input', { type: 'radio', id: id, name: 'mb-qa-option-' + index, value: value, 'data-index': String(index) });
        if (state.values[index] === value) input.checked = true;
        row.appendChild(input);
        row.appendChild(el('label', { class: 'mb-qa__pill', for: id }, value));
      });
      fieldset.appendChild(row);
      ui.body.appendChild(fieldset);
    });
  }

  function update() {
    var product = state.product;
    var values = state.values;
    var missing = values.indexOf(null);
    var variant = missing === -1 ? findVariant(values) : null;
    state.variant = variant;

    Array.prototype.forEach.call(ui.body.querySelectorAll('[data-mb-qa-chosen]'), function (node) {
      node.textContent = values[parseInt(node.getAttribute('data-mb-qa-chosen'), 10)] || 'Select';
    });

    Array.prototype.forEach.call(ui.body.querySelectorAll('input[type="radio"]'), function (input) {
      var test = values.slice();
      test[parseInt(input.getAttribute('data-index'), 10)] = input.value;
      if (input.nextElementSibling) input.nextElementSibling.classList.toggle('is-soldout', !findVariant(test, true));
    });

    ui.price.textContent = '';
    if (variant && variant.compare_at_price > variant.price) {
      ui.price.appendChild(el('mark', {}, money(variant.price)));
      ui.price.appendChild(document.createTextNode(' '));
      ui.price.appendChild(el('s', {}, money(variant.compare_at_price)));
    } else {
      var from = !variant && product.price_varies ? 'From ' : '';
      ui.price.appendChild(el('span', {}, from + money(variant ? variant.price : product.price)));
    }

    var picture = (variant && variant.featured_image && variant.featured_image.src) || product.featured_image;
    if (picture) ui.img.setAttribute('src', sized(picture, 240));

    if (missing !== -1) {
      ui.submit.disabled = true;
      ui.submit.textContent = 'Select ' + optionName(product, missing).toLowerCase();
    } else if (!variant) {
      ui.submit.disabled = true;
      ui.submit.textContent = 'Unavailable';
    } else if (!variant.available) {
      ui.submit.disabled = true;
      ui.submit.textContent = 'Sold out';
    } else {
      ui.submit.disabled = false;
      ui.submit.textContent = 'Add to bag';
    }
  }

  function openSheet(trigger) {
    var handle = trigger.getAttribute('data-mb-quickadd');
    if (!handle) return;
    if (!ui) build();

    state.opener = trigger;
    state.moneyFormat = trigger.getAttribute('data-mb-money-format') || '';
    state.product = null;
    state.variant = null;
    state.busy = false;
    var token = ++state.token;
    var fallbackUrl = trigger.getAttribute('href') || routeRoot + 'products/' + handle;

    ui.more.setAttribute('href', fallbackUrl);
    ui.msg.textContent = '';
    ui.wrap.setAttribute('data-state', 'loading');
    ui.body.textContent = '';
    ui.body.appendChild(el('p', { class: 'mb-qa__loading' }, 'Loading…'));
    ui.title.textContent = '';
    ui.price.textContent = '';
    ui.img.removeAttribute('src');
    ui.submit.disabled = true;
    ui.submit.textContent = 'Select size';

    if (ui.wrap.getAttribute('data-open') !== 'true') {
      state.prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    ui.wrap.setAttribute('data-open', 'true');
    rootEl.setAttribute('data-mb-qa-open', 'true');
    ui.panel.focus();

    load(handle)
      .then(function (product) {
        if (token !== state.token) return;
        state.product = product;
        ui.title.textContent = product.title;
        renderOptions(product);
        ui.wrap.setAttribute('data-state', 'ready');
        update();
        var first = ui.body.querySelector('input[type="radio"]');
        if (first) first.focus({ preventScroll: true });
      })
      .catch(function () {
        if (token === state.token) window.location.href = fallbackUrl;
      });
  }

  function closeSheet() {
    if (!ui || ui.wrap.getAttribute('data-open') !== 'true') return;
    state.token++;
    ui.panel.style.transition = '';
    ui.panel.style.transform = '';
    ui.wrap.setAttribute('data-open', 'false');
    rootEl.removeAttribute('data-mb-qa-open');
    document.body.style.overflow = state.prevOverflow;
    if (state.opener && document.body.contains(state.opener)) state.opener.focus({ preventScroll: true });
  }

  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(routeRoot + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('product');
        return response.json();
      })
      .then(function (product) {
        cache[handle] = product;
        return product;
      });
  }

  function refreshCount() {
    fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        Array.prototype.forEach.call(document.querySelectorAll('[data-mb-cart-count]'), function (node) {
          node.textContent = cart.item_count;
          node.classList.toggle('mb-header__count--zero', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  function add() {
    if (state.busy || !state.variant || !state.variant.available) return;
    state.busy = true;
    ui.submit.disabled = true;
    ui.submit.textContent = 'Adding…';
    ui.msg.textContent = '';

    var variant = state.variant;
    var product = state.product;

    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw body;
          return body;
        });
      })
      .then(function () {
        var label = variant.title !== 'Default Title' ? ' — ' + variant.title : '';
        ui.done.textContent = product.title + label + ' is in your bag.';
        ui.wrap.setAttribute('data-state', 'added');
        refreshCount();
        ui.bag.focus({ preventScroll: true });
      })
      .catch(function (error) {
        ui.msg.textContent = (error && (error.description || error.message)) || 'Could not add this to your bag. Please try again.';
      })
      .then(function () {
        state.busy = false;
        if (ui.wrap.getAttribute('data-state') === 'ready') update();
      });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var trigger = event.target.closest('[data-mb-quickadd]');
    if (trigger) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
      event.preventDefault();
      openSheet(trigger);
    } else if (event.target.closest('[data-mb-qa-close]')) {
      event.preventDefault();
      closeSheet();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!ui || ui.wrap.getAttribute('data-open') !== 'true') return;
    if (event.key === 'Escape') return closeSheet();
    if (event.key !== 'Tab') return;

    var items = ui.panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])');
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (event.shiftKey && (active === first || active === ui.panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();